/**
 * The new entity contract defaults `isUsingConfigAppBackend` to `true` — entities only set it
 * to `false` to opt back to the legacy backend. This utility mirrors that semantic so any
 * entity that omits the flag (mocks, hand-built configs, in-progress work) lands on CACT-BE,
 * not on the legacy path.
 */
export const isUsingConfigAppBackend = ({
  entityLevelOverride,
}: {
  entityLevelOverride?: boolean;
}) => entityLevelOverride !== false;
